import { frontendURL } from 'dashboard/helper/URLHelper';

const QuotesIndex = () => import('./pages/QuotesIndex.vue');
const SalesReport = () => import('./pages/SalesReport.vue');
const DeliveryPaymentReport = () => import('./pages/DeliveryPaymentReport.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/quotes'),
      name: 'quotes_dashboard_index',
      component: QuotesIndex,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/quotes/sales-report'),
      name: 'sales_report',
      component: SalesReport,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/quotes/delivery-report'),
      name: 'delivery_payment_report',
      component: DeliveryPaymentReport,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
